export enum AudienceType {
  E_COMMERCE = 'eCommerce',
  SOCIAL_MEDIA = 'socialMedia',
  PERSONAL = 'personal',
  CREATIVE = 'creative',
  UNSPECIFIED = 'unspecified',
}
